import { Paper, Grid, Checkbox } from '@material-ui/core';
import TextHeader from 'components/CustomText/TextHeader';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import CustomTextField from 'components/Input/CustomTextField';
import NumberListFormItem from '../NumberListFormItem';
import CustomGrid from 'components/Grid/CustomGrid';
import CustomTable from 'components/CustomTable';
import CustomButton from 'components/CustomInput/Button';
import PopupInput from 'components/Application/TeamMemberForm/PopupInput';
import useCoInvestigatorData from 'hooks/tableData/useCoInvestigatorData';
import {
    addRemoveRequest,
    deleteRemoveRequest,
    initializeTableData,
    produce,
    isHighlight as isHL,
} from 'utility/general';
import DataListener from '../DataListener';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import ClusterSelection from 'components/ClusterSelection';
import HospitalOrInstitutions from 'components/Global/HospitalOrInstitutions';
import { useDispatch, useSelector } from 'react-redux';
import {
    UPDATE_FORM_VALIDITY,
    UPDATE_DECLARATION_NORMAL_POST_DATA,
    SET_SITE_VALIDATION,
    UPDATE_DECLARATION_STUDENT_POST_DATA,
    UPDATE_STUDENT,
    UPDATE_COI_INVOLVED,
    UPDATE_DECLARE_STUDENT,
} from 'store/key';
import UploadWrapper from 'components/UploadWrapper';
import { getStore } from 'store';

const SPaperLayout = styled.div`
    padding: 10px;
`;

const SLayout = styled.div`
    padding: 10px;
`;

const PersonalParticularsFormLayout = ({
    onFormUpdate = (key, value) => null,
    onSiteInfoUpdate = (siteInfoId, key, value) => null,
    disableOnPermission = false,
    disableTableOperations = false,
    siteInfoId,
    formId,
    applicationDetail,
    applicationCreateDtm,
    isAmendmentCreate = false,
    isAmendmentEdit = false,
    allComments,
    getCommentDetail,
    isEnableComment,
}) => {
    const {
        openPopup,
        setOpenPopup,
        columns,
        rows,
        setRows,
        defaultFormList,
        selectedRow,
        handleRowCreate,
        onRecordUpdate,
        handleEditClick,
        handleDelete,
        onEditSubmit,
        emptyTableData,
        recoverDataCreation,
        removeAllTempData,
    } = useCoInvestigatorData({ formId, siteInfoId });

    const updatePostData = useSelector((state) => state.applicationDetailPostData?.postData?.siteInfo);

    const currentSiteInfoPostData = updatePostData?.find((item) => item.id === siteInfoId);

    const hasCVFileUploaded = !!currentSiteInfoPostData?.cvFileName;

    const [sitePostData, setSitePostData] = useState(
        currentSiteInfoPostData ? { [currentSiteInfoPostData.id]: currentSiteInfoPostData } : {},
    );

    const siteInfoData = useSelector((state) => state.applicationDetail[formId].siteInfo);
    const currentSiteInfoData = siteInfoData.filter((item) => item.id === siteInfoId)[0] ?? {
        firstName: '',
        surname: '',
        title: '',
    };
    const PIData = useRef({
        firstName: currentSiteInfoData.firstName,
        surname: currentSiteInfoData.surname,
        title: currentSiteInfoData.title,
    });

    const [siteInfoValidation, setSiteInfoValidation] = useState({});

    const validationKey = 'personalParticulars';

    const isAmendment = isAmendmentEdit || isAmendmentCreate;

    const isSiteValid = useSelector(
        (state) => state.applicationDetailValid.siteInfoValid?.[siteInfoId]?.[validationKey],
    );

    // initialize the postData if edit exist
    useEffect(() => {
        const { applicationDetailPostData } = getStore().getState();
        const siteInfo = applicationDetailPostData.postData.siteInfo;
        const currentSiteInfoPostData = siteInfo?.find((item) => item.id === siteInfoId);
        setSitePostData(currentSiteInfoPostData ? { [siteInfoId]: currentSiteInfoPostData } : {});

        const newData = initializeTableData({
            tableKey: 'coi',
            currentTableData: rows,
            siteInfoId,
        });

        setRows(newData);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const dispatch = useDispatch();

    // update site-info validity to the reducer
    useEffect(() => {
        const validations = Object.values(siteInfoValidation);

        // data is not initialized
        if (validations.length === 0) {
            return;
        }

        let currentStatus = validations.every((item) => {
            return item;
        });

        // if (!checkExtraFormValidity()) {
        //     currentStatus = false;
        // }

        if (currentStatus !== isSiteValid) {
            dispatch({
                type: UPDATE_FORM_VALIDITY,
                payload: {
                    type: 'site',
                    applicationFormId: formId,
                    siteInfoId: siteInfoId,
                    formKey: validationKey,
                    isValid: currentStatus,
                },
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteInfoValidation, rows]);

    const shouldCheckOne = () => {
        const isHAStaff = getData('haStaff');
        const isUniversityStaff = getData('uniStaff');
        const isStudent = getData('student');

        let isPass = true;

        if (!(isHAStaff === true || isUniversityStaff === true || isStudent === true)) {
            isPass = false;
        }

        return isPass;
    };

    const updateExtraValidation = () => {
        const atLeastOneSelected = shouldCheckOne();

        setSiteInfoValidation(
            produce((draft) => {
                draft.atLeastOneSelected = atLeastOneSelected;
            }),
        );
    };

    // initialize extra
    useEffect(() => {
        updateExtraValidation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sitePostData]);

    useEffect(() => {
        setTimeout(() => updatePIOfDeclaration(), 1000);
    }, [applicationDetail.siteInfo]);

    const updateSiteValidation = (name, isValidate) => {
        setSiteInfoValidation(
            produce((draft) => {
                draft[name] = isValidate;
            }),
        );
    };

    // when siteInfoValidation change, update the reducer
    useEffect(() => {
        dispatch({
            type: SET_SITE_VALIDATION,
            payload: {
                siteInfoId,
                [validationKey]: siteInfoValidation,
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteInfoValidation]);

    const getDefaultData = (key) => {
        const site = applicationDetail.siteInfo.find((item) => {
            return item.id === siteInfoId;
        });

        return site?.[key];
    };

    const getData = (key) => {
        return sitePostData?.[siteInfoId]?.[key] ?? getDefaultData(key);
    };

    // const checkExtraFormValidity = () => {
    //     // choose at lease one of the role
    //     const isHAStaff = getData('haStaff');
    //     const isUniversityStaff = getData('uniStaff');
    //     const isStudent = getData('student');

    //     let isPass = true;

    //     if (!(isHAStaff === true || isUniversityStaff === true || isStudent === true)) {
    //         isPass = false;
    //     }

    //     //check table data exist if checkbox is check
    //     const isCheck = getData('coiInvolved');
    //     if (isCheck) {
    //         if (rows.length === 0) {
    //             isPass = false;
    //         }
    //     }

    //     return isPass;
    // };

    const onFieldChange = (e) => {
        const { value, name } = e.target;

        setSitePostData((prevData) => {
            const newData = produce(prevData, (draft) => {
                if (!draft[siteInfoId]) {
                    draft[siteInfoId] = {};
                }

                draft[siteInfoId][name] = value;
            });

            return newData;
        });

        onSiteInfoUpdate(siteInfoId, name, value);
        if (name === 'student') {
            if (!isAmendment) {
                /** update document upload item 31 data when student check/unCheck */
                dispatch({
                    type: UPDATE_STUDENT,
                    payload: {
                        student: value,
                        formId: formId,
                        isAmendment,
                    },
                });
            }
            /** update declaration table A student table's data when student check/unCheck */
            dispatch({
                type: UPDATE_DECLARE_STUDENT,
                payload: {
                    student: value,
                    formId,
                    siteInfoId,
                },
            });
        }

        /** update Declaration table A (normal table) data when coiInvolved check/unCheck */
        if (name === 'coiInvolved') {
            dispatch({
                type: UPDATE_COI_INVOLVED,
                payload: {
                    coiInvolved: value,
                    formId: formId,
                    siteInfoId,
                },
            });
        }
    };

    const onCVUploaded = (list) => {
        onSiteInfoUpdate(siteInfoId, 'uploadTempId', list[0].key);
        onFieldChange({
            target: {
                name: 'cvFileName',
                value: list[0].fileName,
            },
        });

        deleteRemoveRequest({
            applicationFormId: formId,
            siteInfoId,
            keys: ['cv', 'cvFileName'],
        });
    };

    const onCVFileRemove = () => {
        addRemoveRequest({
            applicationFormId: formId,
            siteInfoId,
            name: ['cvFileName', 'cv'],
        });

        setSitePostData((prevData) => {
            const newData = produce(prevData, (draft) => {
                if (!draft[siteInfoId]) {
                    draft[siteInfoId] = {};
                }

                draft[siteInfoId].cvFileName = '';
            });

            return newData;
        });
    };

    const isHighlight = (keys, istable = false) => {
        return isHL(applicationDetail, siteInfoId, formId, 'hospital', keys, istable);
    };

    const updatePIOfDeclaration = () => {
        const surname = getData('surname');
        const firstName = getData('firstName');
        const title = getData('title');

        if (firstName && surname && title) {
            dispatch({
                type: UPDATE_DECLARATION_NORMAL_POST_DATA,
                payload: {
                    formId,
                    siteInfoId,
                    firstName: firstName,
                    surname: surname,
                    title: title,
                    roleNameIndex: 0,
                },
            });
        }
    };

    const changeOnBlur = (type, key, e) => {
        if (e && key === 'PI' && PIData.current) {
            /** update declaration normal table (add PI row to declareInv)  */
            const { name, value } = e.target;
            if (value === '') return;

            // get current value of input box, fix issue when auto fill by browser function.
            const surname = getData('surname');
            const firstName = getData('firstName');
            const title = getData('title');

            PIData.current = {
                ...PIData.current,
                surname,
                firstName,
                title,
                [name]: value,
            };

            const data = {
                firstName: name === 'firstName' ? value : PIData.current.firstName,
                surname: name === 'surname' ? value : PIData.current.surname,
                title: name === 'title' ? value : PIData.current.title,
            };

            if (data.firstName && data.surname && data.title) {
                dispatch({
                    type: type,
                    payload: {
                        formId,
                        siteInfoId,
                        firstName: data.firstName,
                        surname: data.surname,
                        title: data.title,
                        roleNameIndex: 0,
                    },
                });
            }
        } else if (e && key === 'Student') {
            /** update declaration student table (add investigator row to declareStudent)  */
            const { name, value } = e.target;
            if (value === '') return;
            const roleNameIndex = name === 'supervisorName' ? 0 : 1;
            dispatch({
                type: type,
                payload: {
                    formId,
                    siteInfoId,
                    roleNameIndex: roleNameIndex,
                    [name]: value,
                },
            });
        }
    };

    return (
        <SPaperLayout>
            {openPopup && (
                <PopupInput
                    title="Co-investigators"
                    height="1000px"
                    width="700px"
                    alignItems={'center'}
                    defaultFormList={defaultFormList}
                    selectedRow={selectedRow}
                    editRow={onEditSubmit}
                    setOpenPopup={setOpenPopup}
                    tableList={rows}
                    onSubmit={onRecordUpdate}
                    returnOriginalData={true}
                />
            )}
            <Paper>
                <DataListener
                    onPostDataReset={() => {
                        //saved finish
                        setSitePostData({});
                        removeAllTempData();
                    }}
                />
                <SLayout>
                    <TextHeader underline italic>
                        PERSONAL PARTICULARS OF SITE PRINCIPAL INVESTIGATOR (PI) AND CO-INVESTIGATOR
                    </TextHeader>

                    <TextSubHeader style={{ marginTop: 20, fontSize: 16 }}>Site Principal Investigator</TextSubHeader>

                    <NumberListFormItem
                        number={'1'}
                        highlight={isHighlight(['title', 'surname', 'firstName', 'chineseName'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '1. Site Principal Investigator',
                            commentStatus: null,
                            commentField: 'title',
                            commentDetail: getCommentDetail("title", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            value={getData('title')}
                            name="title"
                            debounceChange
                            onAppFieldValidate={updateSiteValidation}
                            label={'Title (e.g. Mr, Mrs, Ms, Miss, Dr)'}
                            maxLength={255}
                            onChange={onFieldChange}
                            changeOnBlur={(e) => changeOnBlur(UPDATE_DECLARATION_NORMAL_POST_DATA, 'PI', e)}
                        />
                    </NumberListFormItem>

                    <NumberListFormItem>
                        <CustomGrid numberOfItems={2}>
                            <CustomTextField
                                label={'Surname'}
                                name={'surname'}
                                disableOnPermission={disableOnPermission}
                                debounceChange
                                maxLength={255}
                                onAppFieldValidate={updateSiteValidation}
                                value={getData('surname')}
                                onChange={onFieldChange}
                                changeOnBlur={(e) => changeOnBlur(UPDATE_DECLARATION_NORMAL_POST_DATA, 'PI', e)}
                            />
                            <CustomTextField
                                label={'First Name'}
                                name={'firstName'}
                                disableOnPermission={disableOnPermission}
                                debounceChange
                                maxLength={255}
                                onAppFieldValidate={updateSiteValidation}
                                value={getData('firstName')}
                                onChange={onFieldChange}
                                changeOnBlur={(e) => changeOnBlur(UPDATE_DECLARATION_NORMAL_POST_DATA, 'PI', e)}
                            />
                        </CustomGrid>
                    </NumberListFormItem>

                    <NumberListFormItem>
                        <CustomGrid numberOfItems={2}>
                            <CustomTextField
                                label={'Name in Chinese (Optional)'}
                                disableOnPermission={disableOnPermission}
                                debounceChange
                                maxLength={255}
                                name={'chineseName'}
                                value={getData('chineseName')}
                                onChange={onFieldChange}
                            />
                        </CustomGrid>
                    </NumberListFormItem>

                    <NumberListFormItem
                        number={'2'}
                        label={'Position of the Site Principal Investigator'}
                        bold
                        fontSize={16}
                        style={{ marginTop: 30 }}
                    />

                    <NumberListFormItem number={'2.1'} highlight={isHighlight(['haStaff'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.1 HA Staff (Including HA Honorary staff)',
                            commentStatus: null,
                            commentField: 'haStaff',
                            commentDetail: getCommentDetail("haStaff", allComments),
                        }}
                    >
                        <Checkbox
                            disabled={disableOnPermission}
                            checked={getData('haStaff')}
                            name={'haStaff'}
                            color={'primary'}
                            size={'small'}
                            onChange={(e) => {
                                const { checked, name } = e.target;

                                onFieldChange({
                                    target: {
                                        value: checked,
                                        name,
                                    },
                                });
                            }}
                        />
                        <div style={{ marginLeft: 5, display: 'inline' }}>HA Staff (Including HA Honorary staff)</div>
                    </NumberListFormItem>
                    <NumberListFormItem level={2} number={'2.1.1'} highlight={isHighlight(['haPosition'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.1.1 Position',
                            commentStatus: null,
                            commentField: 'haPosition',
                            commentDetail: getCommentDetail("haPosition", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            debounceChange
                            label={'Position'}
                            name={'haPosition'}
                            maxLength={255}
                            value={getData('haPosition')}
                            onAppFieldValidate={updateSiteValidation}
                            allowAction={getData('haStaff') === true}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={2} number={'2.1.2'} highlight={isHighlight(['haDepartment'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.1.2 Department / Unit',
                            commentStatus: null,
                            commentField: 'haDepartment',
                            commentDetail: getCommentDetail("haDepartment", allComments),
                        }}
                    >
                        <CustomTextField
                            debounceChange
                            label={'Department / Unit'}
                            maxLength={255}
                            disableOnPermission={disableOnPermission}
                            name={'haDepartment'}
                            onAppFieldValidate={updateSiteValidation}
                            value={getData('haDepartment')}
                            allowAction={getData('haStaff') === true}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem
                        level={2}
                        number={'2.1.3'}
                        // label={'Cluster'}
                        highlight={isHighlight(['haClusterCode'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.1.3 Cluster',
                            commentStatus: null,
                            commentField: 'haClusterCode',
                            commentDetail: getCommentDetail("haClusterCode", allComments),
                        }}
                    >
                        <ClusterSelection
                            disableOnPermission={disableOnPermission}
                            style={{ width: 200 }}
                            allowAction={getData('haStaff') === true}
                            name={'haClusterCode'}
                            deleteRequestKey={'haCluster'}
                            value={getData('haClusterCode')}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            onAppFieldValidate={updateSiteValidation}
                            // forceErrorDisplay={forceErrorDisplay}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={2} number={'2.1.4'} highlight={isHighlight(['haHospital'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.1.4 Hospital',
                            commentStatus: null,
                            commentField: 'haHospitalCode',
                            commentDetail: getCommentDetail("haHospitalCode", allComments),
                        }}
                    >
                        <div style={{ width: 200 }}>
                            <HospitalOrInstitutions
                                disableOnPermission={disableOnPermission}
                                label="Hospital"
                                allowAction={getData('haStaff') === true}
                                disabled={!getData('haClusterCode')}
                                allowClusters={getData('haClusterCode') ? [getData('haClusterCode')] : []}
                                name="haHospitalCode"
                                deleteRequestKey={'haHospital'}
                                onAppFieldValidate={updateSiteValidation}
                                showOtherOption
                                isAuthorizedEmail={true}
                                hospitalOrInstitution={getData('haHospitalCode') || ''}
                                disableUniversityChoice
                                updateSiteFormOnDisableChange={siteInfoId}
                                updateApplicationFormOnDisableChange={formId}
                                setHospitalOrInstitution={onFieldChange}
                            />
                        </div>
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.1.4.1'} highlight={isHighlight(['haOther'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.1.4.1 If Other, specify',
                            commentStatus: null,
                            commentField: 'haOther',
                            commentDetail: getCommentDetail("haOther", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'If Other, specify'}
                            maxLength={255}
                            name={'haOther'}
                            debounceChange
                            allowAction={getData('haStaff') === true && getData('haHospitalCode') === 'OTHERS'}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            onAppFieldValidate={updateSiteValidation}
                            value={getData('haOther')}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem number={'2.2'} highlight={isHighlight(['uniStaff'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.2 University Staff',
                            commentStatus: null,
                            commentField: 'uniStaff',
                            commentDetail: getCommentDetail("uniStaff", allComments),
                        }}
                    >
                        <Checkbox
                            disabled={disableOnPermission}
                            checked={getData('uniStaff')}
                            name={'uniStaff'}
                            color={'primary'}
                            size={'small'}
                            onChange={(e) => {
                                const { checked, name } = e.target;
                                onFieldChange({
                                    target: {
                                        value: checked,
                                        name,
                                    },
                                });
                            }}
                        />
                        <div style={{ marginLeft: 5, display: 'inline' }}>University Staff</div>
                    </NumberListFormItem>
                    <NumberListFormItem level={2} number={'2.2.1'} highlight={isHighlight(['uniPosition'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.2.1 Position',
                            commentStatus: null,
                            commentField: 'uniPosition',
                            commentDetail: getCommentDetail("uniPosition", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'Position'}
                            maxLength={255}
                            debounceChange
                            name={'uniPosition'}
                            value={getData('uniPosition')}
                            allowAction={getData('uniStaff') === true}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={2} number={'2.2.2'} highlight={isHighlight(['uniDepartment'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.2.2 Department / School / Faculty',
                            commentStatus: null,
                            commentField: 'uniDepartment',
                            commentDetail: getCommentDetail("uniDepartment", allComments),
                        }}
                    >
                        <CustomTextField
                            label={'Department / School / Faculty'}
                            disableOnPermission={disableOnPermission}
                            debounceChange
                            maxLength={255}
                            name={'uniDepartment'}
                            value={getData('uniDepartment')}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            allowAction={getData('uniStaff') === true}
                            onAppFieldValidate={updateSiteValidation}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem
                        level={2}
                        number={'2.2.3'}
                        label={'University'}
                        highlight={isHighlight(['university'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.2.3 University',
                            commentStatus: null,
                            commentField: 'university',
                            commentDetail: getCommentDetail("university", allComments),
                        }}
                    >
                        <CustomOutlineSelect
                            style={{ paddingLeft: 15, width: 200 }}
                            disableOnPermission={disableOnPermission}
                            name={'university'}
                            value={getData('university')}
                            allowAction={getData('uniStaff') === true}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            onChange={onFieldChange}
                            choices={[
                                { key: 0, display: 'CITYU' },
                                { key: 1, display: 'CUHK' },
                                { key: 2, display: 'HKBU' },
                                { key: 3, display: 'HKU' },
                                { key: 4, display: 'HKUST' },
                                { key: 5, display: 'LU' },
                                { key: 6, display: 'OUHK' },
                                { key: 7, display: 'POLYU' },
                                { key: 8, display: 'Others' },
                            ]}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.2.3.1'} highlight={isHighlight(['uniOther'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.2.3.1 If Other, specify',
                            commentStatus: null,
                            commentField: 'uniOther',
                            commentDetail: getCommentDetail("uniOther", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'If Other, specify'}
                            maxLength={255}
                            debounceChange
                            name={'uniOther'}
                            value={getData('uniOther')}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            allowAction={getData('uniStaff') === true && getData('university') === 8}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>

                    <NumberListFormItem number={'2.3'} highlight={isHighlight(['student'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3 Student',
                            commentStatus: null,
                            commentField: 'student',
                            commentDetail: getCommentDetail("student", allComments),
                        }}
                    >
                        <Checkbox
                            disabled={disableOnPermission}
                            checked={getData('student')}
                            name={'student'}
                            color={'primary'}
                            size={'small'}
                            onChange={(e) => {
                                const { checked, name } = e.target;
                                onFieldChange({
                                    target: {
                                        value: checked,
                                        name,
                                    },
                                });
                            }}
                        />
                        <div style={{ marginLeft: 5, display: 'inline' }}>Student</div>
                    </NumberListFormItem>
                    <NumberListFormItem
                        level={2}
                        number={'2.3.1'}
                        label={'Full-time / Part-time'}
                        highlight={isHighlight(['studentFull'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.1 Full-time / Part-time',
                            commentStatus: null,
                            commentField: 'studentFull',
                            commentDetail: getCommentDetail("studentFull", allComments),
                        }}
                    >
                        <CustomOutlineSelect
                            disableOnPermission={disableOnPermission}
                            style={{ paddingLeft: 15, width: 200 }}
                            name={'studentFull'}
                            allowAction={getData('student') === true}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            value={getData('studentFull')}
                            onChange={onFieldChange}
                            choices={[
                                { key: 'F', display: 'Full-time' },
                                { key: 'P', display: 'Part-time' },
                            ]}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem
                        level={3}
                        number={'2.3.1.1'}
                        label={'Undergraduate / Post-graduate'}
                        highlight={isHighlight(['studentGraduate'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.1.1 Undergraduate / Post-graduate',
                            commentStatus: null,
                            commentField: 'studentGraduate',
                            commentDetail: getCommentDetail("studentGraduate", allComments),
                        }}
                    >
                        <CustomOutlineSelect
                            disableOnPermission={disableOnPermission}
                            style={{ paddingLeft: 15, width: 300 }}
                            name={'studentGraduate'}
                            allowAction={getData('student') === true}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            value={getData('studentGraduate')}
                            onChange={onFieldChange}
                            choices={[
                                { key: 'U', display: 'Undergraduate' },
                                { key: 'P', display: 'Post-graduate' },
                            ]}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.3.1.2'} highlight={isHighlight(['studentDept'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.1.2 Department / School / Faculty',
                            commentStatus: null,
                            commentField: 'studentDept',
                            commentDetail: getCommentDetail("studentDept", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'Department / School / Faculty'}
                            debounceChange
                            maxLength={255}
                            name={'studentDept'}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            value={getData('studentDept')}
                            allowAction={getData('student') === true}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.3.1.3'} highlight={isHighlight(['studentInst'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.1.3 Institute',
                            commentStatus: null,
                            commentField: 'studentInst',
                            commentDetail: getCommentDetail("studentInst", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'Institute'}
                            maxLength={255}
                            debounceChange
                            name={'studentInst'}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            value={getData('studentInst')}
                            allowAction={getData('student') === true}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>

                    <NumberListFormItem level={2} number={'2.3.2'} highlight={isHighlight(['supervisorName'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.2 Name of Academic Supervisor',
                            commentStatus: null,
                            commentField: 'supervisorName',
                            commentDetail: getCommentDetail("supervisorName", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'Name of Academic Supervisor'}
                            name={'supervisorName'}
                            debounceChange
                            maxLength={255}
                            onAppFieldValidate={updateSiteValidation}
                            value={getData('supervisorName')}
                            allowAction={getData('student') === true}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            onChange={onFieldChange}
                            changeOnBlur={(e) => changeOnBlur(UPDATE_DECLARATION_STUDENT_POST_DATA, 'Student', e)}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.3.2.1'} highlight={isHighlight(['supervisorDept'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.2.1 Department / School / Faculty',
                            commentStatus: null,
                            commentField: 'supervisorDept',
                            commentDetail: getCommentDetail("supervisorDept", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'Department / School / Faculty'}
                            name={'supervisorDept'}
                            debounceChange
                            maxLength={255}
                            onAppFieldValidate={updateSiteValidation}
                            value={getData('supervisorDept')}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            allowAction={getData('student') === true}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.3.2.2'} highlight={isHighlight(['supervisorInst'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.2.2 Institute',
                            commentStatus: null,
                            commentField: 'supervisorInst',
                            commentDetail: getCommentDetail("supervisorInst", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            debounceChange
                            label={'Institute'}
                            maxLength={255}
                            name={'supervisorInst'}
                            onAppFieldValidate={updateSiteValidation}
                            value={getData('supervisorInst')}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            allowAction={getData('student') === true}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem
                        level={3}
                        italic
                        label={
                            'Supporting document from academia (please attach in “Study Info” tab - 31 Supporting document from Academia)'
                        }
                    />

                    <NumberListFormItem level={2} number={'2.3.3'} highlight={isHighlight(['siteSupervisorName'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.3 Name of Site supervisor',
                            commentStatus: null,
                            commentField: 'siteSupervisorName',
                            commentDetail: getCommentDetail("siteSupervisorName", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'Name of Site supervisor'}
                            maxLength={255}
                            debounceChange
                            name={'siteSupervisorName'}
                            onAppFieldValidate={updateSiteValidation}
                            value={getData('siteSupervisorName')}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            allowAction={getData('student') === true}
                            onChange={onFieldChange}
                            changeOnBlur={(e) => changeOnBlur(UPDATE_DECLARATION_STUDENT_POST_DATA, 'Student', e)}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.3.3.1'} highlight={isHighlight(['siteSupervisorDept'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.3.1 Department / Unit',
                            commentStatus: null,
                            commentField: 'siteSupervisorDept',
                            commentDetail: getCommentDetail("siteSupervisorDept", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'Department / Unit'}
                            debounceChange
                            maxLength={255}
                            onAppFieldValidate={updateSiteValidation}
                            name={'siteSupervisorDept'}
                            value={getData('siteSupervisorDept')}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            allowAction={getData('student') === true}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>
                    <NumberListFormItem level={3} number={'2.3.3.2'} highlight={isHighlight(['siteSupervisorHosp'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.3.2 Hospital',
                            commentStatus: null,
                            commentField: 'siteSupervisorHospCode',
                            commentDetail: getCommentDetail("siteSupervisorHospCode", allComments),
                        }}
                    >
                        <div style={{ width: 300 }}>
                            <HospitalOrInstitutions
                                disableOnPermission={disableOnPermission}
                                label="Hospital"
                                name="siteSupervisorHospCode"
                                isAuthorizedEmail={true}
                                deleteRequestKey={'siteSupervisorHosp'}
                                updateSiteFormOnDisableChange={siteInfoId}
                                onAppFieldValidate={updateSiteValidation}
                                updateApplicationFormOnDisableChange={formId}
                                // disableUniversityChoice
                                showOtherOption
                                hospitalOrInstitution={getData('siteSupervisorHospCode') || ''}
                                allowAction={getData('student') === true}
                                setHospitalOrInstitution={onFieldChange}
                            />
                        </div>
                    </NumberListFormItem>
                    <NumberListFormItem level={4} number={'2.3.3.2.1'} highlight={isHighlight(['siteSupervisorOther'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.3.3.2.1 If Other, specify',
                            commentStatus: null,
                            commentField: 'siteSupervisorOther',
                            commentDetail: getCommentDetail("siteSupervisorOther", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            label={'If Other, specify'}
                            name={'siteSupervisorOther'}
                            debounceChange
                            maxLength={255}
                            onAppFieldValidate={updateSiteValidation}
                            updateSiteFormOnDisableChange={siteInfoId}
                            updateApplicationFormOnDisableChange={formId}
                            value={getData('siteSupervisorOther')}
                            allowAction={getData('student') === true && getData('siteSupervisorHospCode') === 'OTHERS'}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>

                    <NumberListFormItem number={'2.4'} highlight={isHighlight(['phone'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.4 Phone Number',
                            commentStatus: null,
                            commentField: 'phone',
                            commentDetail: getCommentDetail("phone", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            debounceChange
                            label={'Phone Number'}
                            maxLength={255}
                            onAppFieldValidate={updateSiteValidation}
                            name={'phone'}
                            changeOnBlur={() => {
                                updatePIOfDeclaration();
                            }}
                            value={getData('phone')}
                            onChange={onFieldChange}
                        />
                    </NumberListFormItem>

                    <NumberListFormItem number={'2.5'} highlight={isHighlight(['email'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.5 E-mail address',
                            commentStatus: null,
                            commentField: 'email',
                            commentDetail: getCommentDetail("email", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            debounceChange
                            label={'E-mail address'}
                            maxLength={255}
                            onAppFieldValidate={updateSiteValidation}
                            name={'email'}
                            value={getData('email')}
                            onChange={onFieldChange}
                            changeOnBlur={() => {
                                updatePIOfDeclaration();
                            }}
                            showErrorWhenOnBlur
                        />
                    </NumberListFormItem>

                    <NumberListFormItem number={'2.6'} highlight={isHighlight(['mailing'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.6 Mailing address',
                            commentStatus: null,
                            commentField: 'mailing',
                            commentDetail: getCommentDetail("mailing", allComments),
                        }}
                    >
                        <CustomTextField
                            disableOnPermission={disableOnPermission}
                            debounceChange
                            label={'Mailing address'}
                            maxLength={255}
                            onAppFieldValidate={updateSiteValidation}
                            name={'mailing'}
                            value={getData('mailing')}
                            onChange={onFieldChange}
                            tooltip={'Suggest to provide office address.'}
                            changeOnBlur={() => {
                                updatePIOfDeclaration();
                            }}
                            showErrorWhenOnBlur
                        />
                    </NumberListFormItem>

                    <NumberListFormItem number={'2.7'} highlight={isHighlight(['uploadTempId'])}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '2.7 CV:',
                            commentStatus: null,
                            commentField: 'cv',
                            commentDetail: getCommentDetail("cv", allComments),
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ width: 30 }}>CV: </div>
                            <div style={{ flexGrow: 1 }}>
                                <UploadWrapper
                                    disableOnPermission={disableOnPermission}
                                    name={'cv'}
                                    enableDownload={!hasCVFileUploaded && getDefaultData('cvFileName')}
                                    downloadType={'siteInfo'}
                                    onFileUploadFinish={onCVUploaded}
                                    multiple={false}
                                    isRequired
                                    isValidValue={(isValid) => updateSiteValidation('cvFileName', isValid)}
                                    files={
                                        getData('cvFileName')
                                            ? [{ name: getData('cvFileName'), downloadId: siteInfoId }]
                                            : []
                                    }
                                    enableRemove={!!getData('cvFileName')}
                                    onRemove={onCVFileRemove}
                                />
                            </div>
                        </div>
                    </NumberListFormItem>

                    <NumberListFormItem
                        number={'3'}
                        style={{ marginTop: 30 }}
                        bold
                        label={'Co-investigators'}
                        fontSize={16}
                        highlight={isHighlight(['coi'], true)}
                    />

                    <NumberListFormItem
                        label={'Any Co-investigators Involved in this study?'}
                        showTrueFalse
                        disableOnPermission={disableOnPermission}
                        trueFalseValue={getData('coiInvolved')}
                        name={'coiInvolved'}
                        onAppFieldValidate={updateSiteValidation}
                        onTrueFalseSelected={(e) => {
                            const { value } = e.target;

                            if (value) {
                                recoverDataCreation();
                            } else {
                                emptyTableData();
                            }

                            onFieldChange(e);
                        }}
                        isEnableComment={isEnableComment}
                        commentProps={{
                            commentLabel: '3. Co-investigators',
                            commentStatus: null,
                            commentField: 'coi',
                            commentDetail: getCommentDetail("coi", allComments),
                        }}
                    />
                    <NumberListFormItem
                        displayContentNextLine
                        disableVerticalCenter
                        label={'(Please specify if there is a Lead PI in this study in “Major Responsibility”.)'}
                    >
                        <Grid container>
                            <CustomButton
                                disableOnPermission={disableOnPermission || disableTableOperations}
                                allowAction={getData('coiInvolved') === true}
                                style={{ marginBottom: 8 }}
                                onClick={handleRowCreate}
                            >
                                Add
                            </CustomButton>
                            <CustomTable
                                fullWidthTable
                                disableOnPermission={disableOnPermission || disableTableOperations}
                                rows={rows}
                                allowAction={getData('coiInvolved') === true}
                                columns={columns}
                                disableOldDataDelete={isAmendment}
                                name={'coi'}
                                onAppFieldValidate={updateSiteValidation}
                                isEditAllow
                                isDeleteAllow
                                onDelete={handleDelete}
                                onEdit={handleEditClick}
                                applicationCreateDtm={applicationCreateDtm}
                            />
                        </Grid>
                    </NumberListFormItem>
                </SLayout>
            </Paper>
        </SPaperLayout>
    );
};

export default PersonalParticularsFormLayout;
